<template>
</template>
<script>
	export default {
		data() {
			let vm = this;
			return {
				element: null,
				resources: {
					zIndex: {
						name: 'zIndex',
						defaultValue: '',
						labelDesc: 'zIndex',
						callback: function () {
							vm.resources.zIndex.defaultValue = this.value;
							vm.element.internal_config.zIndex = this.value;

						},
					},
					maxWidth: {
						name: 'maxWidth',
						defaultValue: '500',
						min: '200',
						max: '768',
						labelDesc: 'max-width-tablet',
						callback: function () {
							vm.resources.maxWidth.defaultValue = this.value;
							vm.element.internal_config.maxWidth = this.value + 'px';

						},
					},
					fontSizeMobile: {
						name: 'fontSizeMobile',
						defaultValue: '',
						labelDesc: 'font-size-mobile',
						callback: function () {
							vm.resources.fontSizeMobile.defaultValue = this.value;
							vm.element.internal_config.fontSizeMobile = this.value + 'px';

							vm.element.fontSizeMobileChange();
						},
					},
					alignMobile: {
						name: 'alignMobile',
						defaultValue: '',
						labelDesc: 'align-mobile',
						callback: function () {
							vm.resources.alignMobile.defaultValue;
							vm.element.internal_config.alignMobile = this.value;

							vm.element.alignMobileChange();
						}
					},
					padding: {
						name: 'padding',
						defaultLeft: '15',
						defaultTop: '15',
						defaultRight: '15',
						defaultBottom: '15',
						min: '0',
						max: '100',
						labelDesc: 'padding',
						callback: function () {
							vm.resources.padding.defaultLeft = this.l;
							vm.element.internal_config.paddingLeft = this.l + 'px';

							vm.resources.padding.defaultTop = this.t;
							vm.element.internal_config.paddingTop = this.t + 'px';

							vm.resources.padding.defaultRight = this.r;
							vm.element.internal_config.paddingRight = this.r + 'px';

							vm.resources.padding.defaultBottom = this.b;
							vm.element.internal_config.paddingBottom = this.b + 'px';
						},
					},

          isGradientText:{
            name: 'isGradientText',
						defaultValue: false,
						labelDesc: 'isGradientText',
						callback: function () {

							vm.resources.isGradientText.defaultValue = this.value
							vm.element.internal_config.isGradientText = this.value;

						},
          },

          textGradientColor: {
						name: 'textGradientColor',
						defaultValue: '',
						gradient: true,
						labelDesc: 'text-gradient-color',
						callback: function () {
							vm.resources.textGradientColor.defaultValue = this.colorValue;
							vm.element.internal_config.textGradientColor = this.colorValue;
						},
					},

          checkBoxTextBackgroundHover:{
            name: 'checkBoxTextBackgroundHover',
						defaultValue: '',
						labelDesc: 'checkBoxTextBackgroundHover',
						callback: function () {
							vm.resources.checkBoxTextBackgroundHover.defaultValue = this.value
							vm.element.internal_config.checkBoxTextBackgroundHover = this.value;
						},
          },
					textBackgroundColorHover: {
						name: 'textBackgroundColorHover',
						defaultValue: '#ffffff',
						labelDesc: 'resource-textBackgroundColorHover',
						callback: function () {
							vm.resources.textBackgroundColorHover.defaultValue = this.colorValue;
							vm.element.internal_config.textBackgroundColorHover = this.colorValue;
						},
					},
				}
			}
		},
		methods: {
			setValuesData(data) {
				this.element = data;
				this.resources.maxWidth.defaultValue = parseInt(data.internal_config.maxWidth);

				this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
				this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
				this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
				this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);

				this.resources.fontSizeMobile.defaultValue = parseInt(data.internal_config.fontSizeMobile);
				this.resources.alignMobile.defaultValue = data.internal_config.alignMobile;

        this.resources.checkBoxTextBackgroundHover.defaultValue = data.internal_config.checkBoxTextBackgroundHover;
        this.resources.textBackgroundColorHover.defaultValue = data.internal_config.textBackgroundColorHover;
        this.resources.isGradientText.defaultValue = data.internal_config.isGradientText;
        this.resources.textGradientColor.defaultValue = data.internal_config.textGradientColor;



			},
			getValuesData() {
				return this.resources;
			}
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Text/Resources.vue